<template>
<div class="price-form" v-loading.fullscreen.lock="loading">
  <top :title="title"></top>
  <div class="con">
    <ul class="tw">
      <li class="p-text" v-if="wechatShow==1">
        <span class="label">{{people}}</span>
        <span class="static">{{wechat}}</span>
      </li>
      <li class="p-text" v-if="qqShow==1">
        <span class="label">{{people}}</span>
        <span class="static">{{qq}}</span>
      </li>
      <li class="p-text">
        <span class="label"><b>*</b>会员账号</span>
        <input type="text" name="" id="" v-model="form.account" placeholder="请填写英文、数字">
        <!-- <button class="check-btn" @click="checkAccount">检测账号</button> -->
      </li>
      <template v-if="sale_extend">
        <li class="p-text">
          <span class="label"><b>*</b>VIP等级</span>
          <input type="number" maxlength="10" name="" id="" v-model="form.vip_level" placeholder="请填写VIP等级" >
        </li>
        <li class="p-text">
          <span class="label"><b>*</b>电子等级</span>
          <input type="number" maxlength="10" name="" id="" v-model="form.e_level" placeholder="请填写电子升级模式等级" >
        </li>
        <li class="p-text">
          <span class="label">真人等级</span>
          <input type="number" maxlength="10" name="" id="" v-model="form.r_level" placeholder="请填写真人升级模式等级" >
        </li>
        <li class="p-text">
          <span class="label">电子晋级礼金</span>
          <input type="text" name="" id="" v-model="form.e_up_reward" placeholder="请填写电子晋级礼金">
        </li>
        <li class="p-text" v-if="config_info.week_salary_status === '1'">
          <span class="label">电子周俸禄</span>
          <input type="text" name="" id="" v-model="form.e_week_reward" placeholder="请填写电子周俸禄">
        </li>
        <li class="p-text" v-if="config_info.month_salary_status === '1'">
          <span class="label">电子月俸禄</span>
          <input type="text" name="" id="" v-model="form.e_month_reward" placeholder="请填写电子月俸禄">
        </li>
        <li class="p-text">
          <span class="label">真人晋级礼金</span>
          <input type="text" name="" id="" v-model="form.r_up_reward" placeholder="请填写真人晋级礼金">
        </li>
        <li class="p-text" v-if="config_info.month_salary_status === '1'">
          <span class="label">真人月俸禄</span>
          <input type="text" name="" id="" v-model="form.r_month_reward" placeholder="请填写真人月俸禄">
        </li>
        <li class="p-text">
          <span class="label">电子棋牌累计有效投注</span>
          <input type="text" name="" id="" v-model="form.e_bet_amount" placeholder="请填写电子棋牌累计有效投注">
        </li>
        <li class="p-text">
          <span class="label">真人累计有效投注</span>
          <input type="text" name="" id="" v-model="form.r_bet_amount" placeholder="请填写真人累计有效投注">
        </li>
      </template>
      <template v-if="!sale_extend">
        <li class="p-text">
          <span class="label"><b>*</b>等级</span>
          <input type="number" maxlength="10" name="" id="" v-model="form.e_level" placeholder="请输入您的等级" >
        </li>
        <li class="p-text">
          <span class="label">等级礼金</span>
          <input type="number" maxlength="10" name="" id="" v-model="form.e_up_reward" placeholder="请填写等级礼金，没填默认0" >
        </li>
        <li class="p-text" v-if="config_info.week_salary_status === '1'">
          <span class="label">周俸禄</span>
          <input type="number" maxlength="10" name="" id="" v-model="form.e_week_reward" placeholder="请填写周俸禄，没填默认0" >
        </li>
        <li class="p-text" v-if="config_info.month_salary_status === '1'">
          <span class="label">月俸禄</span>
          <input type="number" maxlength="10" name="" id="" v-model="form.e_month_reward" placeholder="请填写月俸禄，没填默认0" >
        </li>
      </template>
     <!--  <li class="p-text">
        <span class="label">VIP等级</span>
        <input type="text" name="" id="" v-model="form.vip_level" placeholder="请填写VIP等级">
      </li>
      <li class="p-text">
        <span class="label">电子等级</span>
        <input type="text" name="" id="" v-model="form.e_level" placeholder="请填写电子升级模式等级">
      </li>
      <li class="p-text">
        <span class="label">真人等级</span>
        <input type="text" name="" id="" v-model="form.r_level" placeholder="请填写真人升级模式等级">
      </li>
      <li class="p-text">
        <span class="label">电子晋级礼金</span>
        <input type="text" name="" id="" v-model="form.e_up_reward" placeholder="请填写电子晋级礼金">
      </li>
      <li class="p-text">
        <span class="label">电子周俸禄</span>
        <input type="text" name="" id="" v-model="form.e_week_reward" placeholder="请填写电子周俸禄">
      </li>
      <li class="p-text">
        <span class="label">电子月俸禄</span>
        <input type="text" name="" id="" v-model="form.e_month_reward" placeholder="请填写电子月俸禄">
      </li>
      <li class="p-text">
        <span class="label">真人晋级礼金</span>
        <input type="text" name="" id="" v-model="form.r_up_reward" placeholder="请填写真人晋级礼金">
      </li>
      <li class="p-text">
        <span class="label">真人周俸禄</span>
        <input type="text" name="" id="" v-model="form.r_week_reward" placeholder="请填写真人周俸禄">
      </li>
      <li class="p-text">
        <span class="label">真人月俸禄</span>
        <input type="text" name="" id="" v-model="form.r_month_reward" placeholder="请填写真人月俸禄">
      </li> -->
      <li class="p-text" v-if="type==1">
        <span class="label"><b>*</b>您的估值</span>
        <input type="number" name="" id="" v-model="form.assess_price" @keyup="form.assess_price=form.assess_price.replace(/^(0|-[1-9][0-9]*)$/,'')" placeholder="请输入金额">
      </li>
      <li class="p-text" v-if="type===2">
        <span class="label"><b>*</b>出售金额</span>
        <input type="number" name="" id="" v-model="form.recover_price" @keyup="form.recover_price=form.recover_price.replace(/^(0|-[1-9][0-9]*)$/,'')" placeholder="请输入金额">
      </li>
      <li class="p-text" v-if="type===3">
        <span class="label"><b>*</b>出售标价</span>
        <input type="number" name="" id="" v-model="form.sale_price" @keyup="form.sale_price=form.sale_price.replace(/^(0|-[1-9][0-9]*)$/,'')" placeholder="请输入金额">
      </li>
      <li class="p-text" v-if="type===3">
        <span class="label">其他</span>
        <textarea name="" id="" cols="30" rows="10" placeholder="你可以补充说明出售账号信息" v-model="form.others"></textarea>
      </li>
    </ul>
    <div class="tip activityDesc" v-show="type === 1" v-html="isassess_description"></div>
    <div class="tip activityDesc" v-show="type === 2" v-html="isrecover_description"></div>
    <div class="tip activityDesc" v-show="type === 3" v-html="issell_description"></div>
    <button class="p-btn" @click="submit">确认提交</button>
  </div>
</div>
</template>

<script>
import top from '@/components/common/top/top'
import { userResource } from '@/resource/resource'
import { mapState } from 'vuex'

const ERR_OK = 0

export default {
  name: 'priceForm',
  props: {
      title: {
        type: String
      },
      type: {
        type: Number,
        default: 1 // 1 evaluate 2 recover 3 sell
      },
      wechatShow: {
        type: String
      },
      wechat: {
        type: String
      },
      qqShow: {
        type: String
      },
      qq: {
        type: String
      },
      sale_extend: {
        type: Number
      },
      recover_description: {
        type: String
      },
      assess_description: {
        type: String
      },
      sell_description: {
        type: String
      }
  },
  data () {
    return {
      form: {
        account: '', // *
        user_level: null,
        level_gift: null,
        vip_level: null,
        week_salary: null,
        month_salary: null,
        // vip_level: null, // * i
        e_level: null, // * i
        r_level: null, // * i
        e_up_reward: null,
        e_week_reward: null,
        e_month_reward: null,
        // r_up_reward: null,
        // r_week_reward: null,
        // r_month_reward: null,
        assess_price: null, // *
        recover_price: null, // *
        sale_price: null, // *
        e_bet_amount: null,
        r_bet_amount: null,
        others: ''
      },
      loading: false,
      people: '',
      isrecover_description: '',
      isassess_description: '',
      issell_description: ''
    }
  },
  computed: {
    ...mapState(['config_info'])
  },
  created () {
    if (this.$route.name === 'sell') {
      this.people = '请添加出售专员'
    } else if (this.$route.name === 'evaluate-acc') {
      this.people = '请添加评估专员'
    } else if (this.$route.name === 'recover-acc') {
      this.people = '请添加回收专员'
    }
  },
  mounted() {
      this.getReplace()
    },
  methods: {
    getReplace(text) {
        // 換行
        this.isrecover_description = this.config_info.recover_description.replace(/(\n|\r|\r\n|↵)/g, '<br/>')
        this.isassess_description = this.config_info.assess_description.replace(/(\n|\r|\r\n|↵)/g, '<br/>')
        this.issell_description = this.config_info.sell_description.replace(/(\n|\r|\r\n|↵)/g, '<br/>')
      },
    checkAccount() {
      if (!this.form.account) {
        this.$alert('会员账号不能为空', '温馨提示', {
          confirmButtonText: '确定'
        })
        return
      }
      this.loading = true
      userResource.check({account: this.form.account}).then(res => {
        res = res.body
        this.loading = false
        if (res.errcode === ERR_OK) {
          this.form.user_level = Number(res.data.user_level)
          this.form.level_gift = Number(res.data.level_gift)
          this.form.week_salary = Number(res.data.week_salary)
          this.form.month_salary = Number(res.data.month_salary)
        }
      })
    },
    submit() {
      if (!this.form.account) {
        this.$alert('会员账号不能为空', '温馨提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (this.sale_extend) {
        if (!this.form.vip_level) {
          this.$alert('VIP等级不能为空', '温馨提示', {
            confirmButtonText: '确定'
          })
          return
        }
        if (!this.form.e_level) {
          this.$alert('等级不能为空', '温馨提示', {
            confirmButtonText: '确定'
          })
          return
        }
      }
      if (!this.form.assess_price && this.type === 1) {
        this.$alert('您的估值不能为空', '温馨提示', {
          confirmButtonText: '确定'
        })
        return
      } else if (!this.form.recover_price && this.type === 2) {
        this.$alert('出售金额不能为空', '温馨提示', {
          confirmButtonText: '确定'
        })
        return
      } else if (!this.form.sale_price && this.type === 3) {
        this.$alert('出售标价不能为空', '温馨提示', {
          confirmButtonText: '确定'
        })
        return
      }
      let ret = {
        account: this.form.account, // *
        r_level: this.form.r_level,
        vip_level: this.form.vip_level, // *
        e_level: this.form.e_level, // * *
        e_up_reward: this.form.e_up_reward,
        e_week_reward: this.form.e_week_reward,
        e_month_reward: this.form.e_month_reward,
        r_up_reward: this.form.r_up_reward,
        r_month_reward: this.form.r_month_reward,
        e_bet_amount: this.form.e_bet_amount,
        r_bet_amount: this.form.r_bet_amount
      }
      let ret2 = {
        account: this.form.account, // *
        e_level: this.form.e_level, // *
        e_up_reward: this.form.e_up_reward, // *
        e_week_reward: this.form.e_week_reward,
        e_month_reward: this.form.e_month_reward
      }
      if (this.type === 1) {
        ret.assess_price = this.form.assess_price
        ret2.assess_price = this.form.assess_price
      }
      if (this.type === 2) {
        ret.recover_price = this.form.recover_price
        ret2.recover_price = this.form.recover_price
      }
      if (this.type === 3) {
        ret.sale_price = this.form.sale_price
        ret2.sale_price = this.form.sale_price
        ret.others = this.form.others
        ret2.others = this.form.others
      }
      if (this.sale_extend === 0) {
        if (!this.form.e_month_reward) {
          ret2.e_month_reward = 0
        }
        if (!this.form.week_salary) {
          ret2.week_salary = 0
        }
        if (!this.form.month_salary) {
          ret2.month_salary = 0
        }
        this.$emit('submit', ret2)
      } else {
        this.$emit('submit', ret)
      }
    },
    clearForm() {
      this.form = {
        account: '', // *
        user_level: null,
        level_gift: null,
        week_salary: null,
        month_salary: null,
        vip_level: null, // *
        e_level: null, // *
        r_level: null, // *
        e_up_reward: null,
        e_week_reward: null,
        e_month_reward: null,
        r_up_reward: null,
        // r_week_reward: null,
        r_month_reward: null,
        e_bet_amount: null,
        r_bet_amount: null,
        assess_price: null, // *
        recover_price: null, // *
        sale_price: null, // *
        others: ''
      }
    }
  },
  components: {
    top
  }
}
</script>

<style lang="stylus" scoped>
.price-form
  .con
    padding 35px 0
    border solid 1px #dcdcdc
    text-align center
    .tw
      .p-text
        // float left
        // width 600px
        padding-left 105px
        margin-bottom 8px
        overflow hidden
        display flex
        .label
          color #959595
          font-size 14px
          display inline-block
          line-height 34px
          width 110px
          text-align right
          margin-right 35px
          & > b
            display inline-block
            color #cd3c29
            margin-right 3px
        .static
          font-size 14px
          line-height 34px
          color #313131
        & > input
          width 238px
          height 32px
          color #959595
          font-size 13px
          line-height 32px
          border solid 1px #dcdcdc
          border-radius 2px
          text-indent 1em
          outline none
          background none
        & > textarea
          width 600px
          height 83px
          color #959595
          font-size 13px
          line-height 22px
          border solid 1px #dcdcdc
          border-radius 2px
          text-indent 1em
          outline none
          background none
        .check-btn
          background $primary
          border 0
          outline none
          border-radius 6px
          color #fff
          margin-left 20px
          cursor pointer
          padding 1px 22px
    .tip
      color #288cea
      font-size 14px
      margin-top 20px
      padding-left 230px
      text-align left
      line-height: 28px
      &.other
        margin-top 15px
    .p-btn
      width 159px
      height 40px
      background-color #288cea
      color #fff
      font-size 16px
      border 0
      outline none
      cursor pointer
      border-radius 2px
      margin-top 20px
</style>



// WEBPACK FOOTER //
// priceForm.vue?413c5ace